/**
 *
 * ContainerDrillDown
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { compose } from "redux"
import DrillDown from "../DrillDown"
import "./index.less"
import { isEqual } from "lodash"

const getParent = (root, id) => {
  let node

  root.some((n) => {
    if (n.id === id) {
      return (node = n)
    }
    if (n.childs) {
      return (node = getParent(n.childs, id))
    }
  })
  return node || null
}

/* eslint-disable react/prefer-stateless-function */
export class ContainerDrillDown extends React.Component {
  state = {
    dataAll: [],
    dataCurrent: [],
    dataParent: {},
    loading: false,
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.data, this.props.data)) {
      this.setState({
        dataParent: {},
        dataCurrent: nextProps.data,
      })
    }
  }

  onClickBar = (e) => {
    this.setState({ loading: true })
    this.setState({ dataCurrent: e.childs, loading: false, dataParent: e })
  }

  onClickBack = (e) => {
    let data = []
    const parent = getParent(this.props.data, e.id_parent)
    let dataParent = e.id_parent == 0 || !e.id_parent ? {} : parent
    if (!parent) {
      data = this.props.data
      dataParent = {}
    } else {
      data = parent.childs
    }
    this.setState({
      dataCurrent: data,
      dataParent,
    })
  }

  render() {
    const { dataCurrent, dataParent } = this.state
    const {
      data,
      isLoading,
      metric,
      bubbles,
      textLeyend,
      bubblesNumber,
      measure_general,
      isDimensions,
      isTooltip,
    } = this.props
    return (
      <div className="ContainerDrillDown">
        <DrillDown
          bubbles={bubbles}
          isDimensions={isDimensions}
          isTooltip={isTooltip}
          loading={isLoading}
          dataAll={data}
          dataCurrent={dataCurrent}
          dataParent={dataParent}
          textLeyend={textLeyend}
          onClickBack={(e) => this.onClickBack(e)}
          lineValue={metric}
          onClickBar={(e) => this.onClickBar(e)}
          bubblesNumber={bubblesNumber}
          measure_general={measure_general}
        />
      </div>
    )
  }
}

ContainerDrillDown.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isDimensions: PropTypes.bool,
  isTooltip: PropTypes.bool,
}

function mapDispatchToProps(dispatch) {
  return { dispatch }
}

const withConnect = connect(null, mapDispatchToProps)

export default compose(withConnect)(ContainerDrillDown)
